<script>
  export let data;
  let result;
  let focus = false;
  $: attributes = { name: data.key };
</script>

<div>
  <input
    class="input-email"
    bind:value={result}
    aria-label={data.placeholder}
    on:blur={() => (focus = false)}
    on:focus={() => (focus = true)}
    data-focus={focus || !!result}
    type="email"
    {...attributes} />

  {#if data.required}
    <strong>*</strong>
  {/if}

  <span>
    {data.placeholder}
  </span>
</div>
